import { SET_LOGGED_IN } from '../action-list'

export const setLoggedIn = (isLoggedIn) => ({
  type: SET_LOGGED_IN,
  isLoggedIn,
})
